import type { ReactNode } from 'react';

import { DialogContent } from '../../../../../components/Dialog/DialogContent';
import { DialogHeader } from '../../../../../components/Dialog/DialogHeader';

import styles from './PocViewConstructor.module.scss';

export function PocViewConstructor(props: {
  title: ReactNode;
  content: ReactNode;
  onGoBack?: VoidFunction;
  onClose?: VoidFunction;
}) {
  return (
    <div className="poc_overrideable">
      <DialogHeader className={styles.header} title={props.title} onClose={props.onClose} onGoBack={props.onGoBack} />
      <DialogContent className={styles.content}>{props.content}</DialogContent>
    </div>
  );
}
